import { createStackNavigator } from "@react-navigation/stack"
import type { CreateOrEditGroupStackParamList } from "src/types.d"

export const CreateOrEditGroupStack = createStackNavigator<CreateOrEditGroupStackParamList>()
